jQuery($ => {
    class ChartComponent {
        constructor(element, defaults) {
            this._ = element;
            this._element = $(element);
            this._id = this._element.attr('id');
            this._data = {};
            this._dataDefaults = {};
            this._dataset = {};
            this._datasetDefaults = {};
            this._axis = this._element.attr('data-cjs-axis');
            this._chartType = this._element.attr('data-cjs-type');
            this._chart;

            this.init();
        }

        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Initialize
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        init() {
            this.setupHandlers();
            this._element.trigger('init', this);
        }


        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Setup Handlers
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        setupHandlers() {
            this.handleData();
            this.handleDataset();
            this.handleChartInit();
            console.log('loaded');
        }


        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Handle Chart Init
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        handleChartInit = () => {
            this._chart = new Chart(this._id, {
                type: this._chartType,
                data: {
                    ...this._dataDefaults,
                    ...this._data,
                    datasets: [{ ...this._datasetDefaults, ...this._dataset }]
                },
                plugins: [ChartDataLabels],
                options: this.handleOptions()
            });
        }


        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Handle Options
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        handleOptions = () => {
            switch (this._chartType) {
                case 'bar':
                case 'line':
                    return {
                        responsive: true,
                        indexAxis: this._axis,
                        scales: {
                            y: {
                                beginAtZero: true
                            }
                        },
                        plugins: {
                            legend: {
                                display: false
                            }, 
                            datalabels: { 
                                color: '#ffffff'
                            }
                        }
                    }

                case 'pie':
                case 'doughnut':
                    return {
                        responsive: true,
                        cutout: '60%',
                        borderWidth: 4, 
                        borderColor: '#1E3869',
                        maintainAspectRatio: true,
                        plugins: {
                            // percentageInnerCutout: 80,
                            legend: {
                                position: 'bottom',
                                padding: 20,
                                labels: {
                                    usePointStyle: true,
                                    color: '#000000',
                                    padding: 20,
                                    font: {
                                        size: 16,
                                        family: 'canada-type-gibson, sans-serif',
                                        weight: '500'
                                    }
                                },
                            },
                            datalabels: {
                                formatter: (value, ctx) => {
                                    if (value == 0) return null;
                                    let sum = ctx.dataset.data.reduce((b, a) => parseInt(b) + parseInt(a), 0);
                                    let percentage = (value * 100 / sum).toFixed(2) + "%";
                                    return percentage;
                                }, 
                                color: '#1E3869',
                                textAlign: 'center',
                                font: {
                                    size: 12,
                                    family: 'canada-type-gibson, sans-serif',
                                    weight: '500'
                                },
                            }
                        },
                    }

                default:
                    return {
                        responsive: true
                    }
            }
        }



        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Handle Key
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        handleKey = (key, remove = 'cjs') => {
            return key
                .replace(remove, '')
                .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
                    return index === 0 ? word.toLowerCase() : word.toUpperCase();
                })
                .replace(/\s+/g, '');
        }


        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Handle Parse Data
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        handleParseData = (text) => {
            let parsed;
            try {
                parsed = JSON.parse(text);
            } catch (error) {
                parsed = text;
            }
            return parsed;
        }


        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Handle Data Object
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        handleDataObject = (attr, object) => {
            const keys = Object.keys(this._element.data())
                .filter(key => key.startsWith(attr));

            keys.forEach(key => {
                const dataAttr = this._element.data(key);
                const dataKey = this.handleKey(key, attr);

                object[dataKey] = this.handleParseData(dataAttr);
            });
        }


        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Handle Data
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        handleData = () => {
            this.handleDataObject('cjsDt', this._data);
        }


        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
        // ✅ Handle Dataset
        //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

        handleDataset = () => {
            this.handleDataObject('cjsDs', this._dataset);
        }
    }


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $.fn.chart = function () {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if (typeof opt == 'object' || typeof opt == 'undefined')
                _[i].chart = new ChartComponent(_[i], opt);
            else
                ret = _[i].chart[opt].apply(_[i].chart, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $('.a-chart').chart();


});